export const DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM = 'digitalSavings/personalDetailsForm/';

export const DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM + 'setValue';
export const DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM + 'setValid';

export const FORM_VALID_DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM =
    'digitalSavings/personalDetailsForm/transition/formValid';
export const FORM_INVALID_DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM =
    'digitalSavings/personalDetailsForm/transition/formInValid';

export const REINITIALIZE = 'digitalSavings/personalDetailsForm/state/reinitialize';

export const transitionDigitalSavingsPersonalDetails = {
    formValid: () => ({
        type: FORM_VALID_DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM,
    }),
    formInvalid: () => ({
        type: FORM_INVALID_DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM,
    }),
};

// API Calls actions
export const API_INITIAL_TRANSITION_PERSONAL_DETAILS_FORM = `${DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE}/apiTransition/initial`;
export const API_PENDING_TRANSITION_PERSONAL_DETAILS_FORM = `${DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITION_PERSONAL_DETAILS_FORM = `${DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE}/apiTransition/success`;
export const API_FAILURE_TRANSITION_PERSONAL_DETAILS_FORM = `${DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE}/apiTransition/failure`;

export const COLLECT_PERSONAL_DETAILS_FORM = `${DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE}/apiTransition/collect/personalDetails`;

export const apiTransitionDigitalSavingsPersonalDetailsForm = {
    initial: () => ({
        type: API_INITIAL_TRANSITION_PERSONAL_DETAILS_FORM,
    }),
    pending: () => ({
        type: API_PENDING_TRANSITION_PERSONAL_DETAILS_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_PERSONAL_DETAILS_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_PERSONAL_DETAILS_FORM,
    }),
};

export const PERSONAL_DETAIL_ID_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'personalDetailId';
export const PERSONAL_DETAIL_ID_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'personalDetailId';

export const FIRST_NAME_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'firstName';
export const FIRST_NAME_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'firstName';

export const TITLE_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'title';
export const TITLE_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'title';

export const SURNAME_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'surname';
export const SURNAME_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'surname';

export const DOB_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'dob';
export const DOB_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'dob';

export const EMAIL_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'email';
export const EMAIL_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'email';

export const MOBILE_NUMBER_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'mobileNumber';
export const MOBILE_NUMBER_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'mobileNumber';

export const ID_PASSPORT_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'idPassport';
export const ID_PASSPORT_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'idPassport';

export const ID_NUMBER_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'idNumber';
export const ID_NUMBER_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'idNumber';

export const PASSPORT_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'passportNumber';
export const PASSPORT_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'passportNumber';

export const KRA_PIN_NUMBER_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'kraPinNumber';
export const KRA_PIN_NUMBER_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'kraPinNumber';

export const GENDER_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'gender';
export const GENDER_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'gender';

export const FULL_ADDRESS_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'fullAddress';
export const FULL_ADDRESS_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'fullAddress';

export const POSTAL_ADDRESS_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'postalAddress';
export const POSTAL_ADDRESS_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'postalAddress';

export const NATIONALITY_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'nationality';
export const NATIONALITY_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'nationality';

export const OCCUPATION_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'occupation';
export const OCCUPATION_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'occupation';

export const SOURCE_OF_FUNDS_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'sourceOfFunds';
export const SOURCE_OF_FUNDS_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'sourceOfFunds';

export const SOURCE_OF_OTHER_FUNDS_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'sourceOfOtherFunds';
export const SOURCE_OF_OTHER_FUNDS_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'sourceOfOtherFunds';

export const EMPLOYER_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'employerName';
export const EMPLOYER_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'employerName';

export const SALARY_RANGE_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'salaryRange';
export const SALARY_RANGE_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'salaryRange';

export const SOURCE_OF_FUNDS_DETAILS_SET_VALUE =
    DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'sourceOfFundsDetails';
export const SOURCE_OF_FUNDS_DETAILS_SET_VALID =
    DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'sourceOfFundsDetails';

export const FUNDS_FROM_LEGITIMATE_SOURCE_SET_VALUE =
    DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'fundsFromLegitimateSource';
export const FUNDS_FROM_LEGITIMATE_SOURCE_SET_VALID =
    DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'fundsFromLegitimateSource';

export const INFO_TRUE_AND_CORRECT_SET_VALUE =
    DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'informationIsTrueAndCorrect';
export const INFO_TRUE_AND_CORRECT_SET_VALID =
    DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'informationIsTrueAndCorrect';

export const ACCEPT_PRIVACY_NOTICE_SET_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'acceptPrivacyNotice';
export const ACCEPT_PRIVACY_NOTICE_SET_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'acceptPrivacyNotice';

export const SET_REFERRED_VALUE = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'referred';
export const SET_REFERRED_VALID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALID + 'referred';

export const SET_QUOTE_ID = DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM_SET_VALUE + 'quoteId';

// Action Creators

export const setFirstNameValue = (value) => ({
    type: FIRST_NAME_SET_VALUE,
    value,
});

export const setFirstNameValid = (error) => ({
    type: FIRST_NAME_SET_VALID,
    error,
});

export const setTitleValue = (value) => ({
    type: TITLE_SET_VALUE,
    value,
});

export const setTitleValid = (error) => ({
    type: TITLE_SET_VALID,
    error,
});

export const setPostalBoxValue = (value) => ({
    type: POSTAL_ADDRESS_SET_VALUE,
    value,
});

export const setPostalBoxValid = (error) => ({
    type: POSTAL_ADDRESS_SET_VALID,
    error,
});

export const setSurnameValue = (value) => ({
    type: SURNAME_SET_VALUE,
    value,
});

export const setSurnameValid = (error) => ({
    type: SURNAME_SET_VALID,
    error,
});

export const setDobValue = (value) => ({
    type: DOB_SET_VALUE,
    value,
});

export const setDobValid = (error) => ({
    type: DOB_SET_VALID,
    error,
});

export const setEmailValue = (value) => ({
    type: EMAIL_SET_VALUE,
    value,
});

export const setEmailValid = (error) => ({
    type: EMAIL_SET_VALID,
    error,
});

export const setMobileNumberValue = (value) => ({
    type: MOBILE_NUMBER_SET_VALUE,
    value,
});

export const setMobileNumberValid = (error) => ({
    type: MOBILE_NUMBER_SET_VALID,
    error,
});

export const setIdPassportValue = (value) => ({
    type: ID_PASSPORT_SET_VALUE,
    value,
});

export const setIdPassportValid = (error) => ({
    type: ID_PASSPORT_SET_VALID,
    error,
});

export const setKraPinNumberValue = (value) => ({
    type: KRA_PIN_NUMBER_SET_VALUE,
    value,
});

export const setKraPinNumberValid = (error) => ({
    type: KRA_PIN_NUMBER_SET_VALID,
    error,
});

export const setGenderValue = (value) => ({
    type: GENDER_SET_VALUE,
    value,
});

export const setGenderValid = (error) => ({
    type: GENDER_SET_VALID,
    error,
});

export const setFullAddressValue = (value) => ({
    type: FULL_ADDRESS_SET_VALUE,
    value,
});

export const setFullAddressValid = (error) => ({
    type: FULL_ADDRESS_SET_VALID,
    error,
});

export const setNationalityValue = (value) => ({
    type: NATIONALITY_SET_VALUE,
    value,
});

export const setNationalityValid = (error) => ({
    type: NATIONALITY_SET_VALID,
    error,
});

export const setOccupationValue = (value) => ({
    type: OCCUPATION_SET_VALUE,
    value,
});

export const setOccupationValid = (error) => ({
    type: OCCUPATION_SET_VALID,
    error,
});

export const setSourceOfFundsValue = (value) => ({
    type: SOURCE_OF_FUNDS_SET_VALUE,
    value,
});

export const setSourceOfFundsValid = (error) => ({
    type: SOURCE_OF_FUNDS_SET_VALID,
    error,
});

export const setSourceOfOtherFundsValue = (value) => ({
    type: SOURCE_OF_OTHER_FUNDS_SET_VALUE,
    value,
});

export const setSourceOfOtherFundsValid = (error) => ({
    type: SOURCE_OF_OTHER_FUNDS_SET_VALID,
    error,
});

export const collectPersonalDetails = () => ({
    type: COLLECT_PERSONAL_DETAILS_FORM,
});

export const setQuoteId = (value) => ({
    type: SET_QUOTE_ID,
    value,
});

export const setPersonalDetailId = (value) => ({
    type: PERSONAL_DETAIL_ID_SET_VALUE,
    value,
});

export const setPersonalDetailIdValid = (error) => ({
    type: PERSONAL_DETAIL_ID_SET_VALID,
    error,
});

export const setIdNumberValue = (value) => ({
    type: ID_NUMBER_SET_VALUE,
    value,
});
export const setIdNumberValid = (error) => ({
    type: ID_NUMBER_SET_VALID,
    error,
});

export const setPassportValue = (value) => ({
    type: PASSPORT_SET_VALUE,
    value,
});
export const setPassportValid = (error) => ({
    type: PASSPORT_SET_VALID,
    error,
});

export const setEmployerNameValue = (value) => ({
    type: EMPLOYER_SET_VALUE,
    value,
});
export const setEmployerNameValid = (error) => ({
    type: EMPLOYER_SET_VALID,
    error,
});

export const setSalaryRangeValue = (value) => ({
    type: SALARY_RANGE_SET_VALUE,
    value,
});
export const setSalaryRangeValid = (error) => ({
    type: SALARY_RANGE_SET_VALID,
    error,
});

export const setSourceOfFundsDetailsValue = (value) => ({
    type: SOURCE_OF_FUNDS_DETAILS_SET_VALUE,
    value,
});
export const setSourceOfFundsDetailsValid = (error) => ({
    type: SOURCE_OF_FUNDS_DETAILS_SET_VALID,
    error,
});

export const setFundsFromLegitimateSourceValue = (value) => ({
    type: FUNDS_FROM_LEGITIMATE_SOURCE_SET_VALUE,
    value,
});
export const setFundsFromLegitimateSourceValid = (error) => ({
    type: FUNDS_FROM_LEGITIMATE_SOURCE_SET_VALID,
    error,
});

export const setInformationTrueAndCorrectValue = (value) => ({
    type: INFO_TRUE_AND_CORRECT_SET_VALUE,
    value,
});
export const setInformationTrueAndCorrectValid = (error) => ({
    type: INFO_TRUE_AND_CORRECT_SET_VALID,
    error,
});

export const setAcceptNoticeValue = (value) => ({
    type: ACCEPT_PRIVACY_NOTICE_SET_VALUE,
    value,
});
export const setAcceptNoticeValid = (error) => ({
    type: ACCEPT_PRIVACY_NOTICE_SET_VALID,
    error,
});

export const setReferredValue = (value) => ({
    type: SET_REFERRED_VALUE,
    value,
});
export const setReferredValid = (error) => ({
    type: SET_REFERRED_VALID,
    error,
});
